import { useState } from "react";
import { getInitialFilterValues, buildFilterQuery } from "./utils";

import type { CheckedFilter, Filter } from "../../../site/parts/listSearch/type.d";

interface UseListSearchFilterProps {
  filterLists: Filter[];
  filterFromParams: string[];
}

export function useListSearchFilter({ filterLists, filterFromParams }: UseListSearchFilterProps) {
  const initialValues = getInitialFilterValues(filterLists, filterFromParams);

  const [currentFilter, setCurrentFilter] = useState<CheckedFilter[]>(initialValues);
  const [isFilterOpen, setIsFilterOpen] = useState(filterFromParams?.length > 0);
  const [countChecked, setCountChecked] = useState(filterFromParams?.length || 0);

  const getFilterQuery = (): string => buildFilterQuery(currentFilter);

  const handleFilterSelected = (checkedValues: string[], field: string): void => {
    setCurrentFilter((prevFilter) => prevFilter.map((filterObj) => {
      if (filterObj.field === field) {
        return { ...filterObj, values: checkedValues };
      }
      return filterObj;
    }));
  };

  const resetDisplayedFilter = (): void => {
    setCurrentFilter(
      currentFilter.map((filterObj) => ({
        ...filterObj,
        values: []
      }))
    );
  };

  return {
    currentFilter,
    isFilterOpen,
    setIsFilterOpen,
    countChecked,
    setCountChecked,
    getFilterQuery,
    handleFilterSelected,
    resetDisplayedFilter
  };
}
